import type { ReactNode } from "react";
import { useSession } from "../../app/session.js";
import { Notice } from "../../ui/index.js";
import { useLogout } from "../cabinet/index.js";

/**
 * Верхняя строка страниц админки без оболочки кабинета (список салонов, карточка салона):
 * кто вошёл и «Выйти». Выход тот же, что в «Ещё» кабинета (`useLogout`); после него `RequireAdmin` уводит на вход.
 * Страница рисует строку и пока данные грузятся, и при ошибке загрузки: выйти можно всегда.
 */
export function AdminTopBar({ left, className = "" }: { left?: ReactNode; className?: string }) {
  const session = useSession();
  const { logout, pending, error } = useLogout();
  return (
    <div className={className}>
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-sm text-slate-500">
        <div>{left}</div>
        <div className="flex min-w-0 items-center gap-3">
          <span className="truncate">{session.user?.email}</span>
          <button type="button" className="shrink-0 underline" onClick={() => void logout()} disabled={pending}>
            Выйти
          </button>
        </div>
      </div>
      {error && (
        <div className="mt-2">
          <Notice kind="error">Не удалось выйти: {error.message}</Notice>
        </div>
      )}
    </div>
  );
}
